<template>
  <q-input
    :model-value="modelValue"
    placeholder="Search for a country..."
    @update:model-value="$emit('update:modelValue', $event)"
    class="country-search bg-white q-px-sm"
  >
    <template v-slot:prepend>
      <q-icon name="fa fa-search" />
    </template>
  </q-input>
</template>

<style lang="scss" scoped>
.country-search {
  position: sticky;
  top: 0;
  z-index: 10;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    modelValue: String,
  },
  mounted(): void {
    // Better to use setTimeout() instead of $nextTick() due to CSS transitions
    setTimeout(() => {
      const input = this.$el.querySelector('input');
      if (input) input.focus();
    }, 100);
  },
});
</script>
